<template>
  <div class="dice">
    <b-row>
    <b-list-group style="border: 1px solid #333; padding: 0; margin-top: 20px;">
      <b-list-group-item style="text-align: center; font-size: 16px; padding: 0rem !important;">
        <strong>Related Views</strong>
      </b-list-group-item>
      <b-list-group-item><img src="img/proj.gif" /><br> Item</b-list-group-item>
      <b-list-group-item><img src="img/proj.gif" /><br> PurchaseRFQ</b-list-group-item>
      <b-list-group-item><img src="img/proj.gif" /><br> PurchaseOrder</b-list-group-item>
    </b-list-group>
  </b-row>
  </div>
</template>

<script>
export default {
  name: 'DiceNav',
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.group .list-group{
      margin-left: 25px;
    margin-top: 15px;
    border: 1px solid #333;
    width: 225px;
    padding: 0;
}
.dice .list-group-item{
  background: transparent;
  text-align: center;
      border: 2px solid #fff;
    padding: 1rem 0rem;
    font-size: 12px;
    font-weight: 600;
}
.group .list-group-item img{
  border-right: 2px solid #fff;
    padding: 0px 25px 0px 5px;
    background: #bbc7d6;
}
</style>
